import { api, createCancelTokenHandler } from '../../vodea/services';

const endPoint = () => process.env.REACT_APP_PASSPORT_END_POINT;

const Repository = {
  all: function (vendorId: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/vendor/${vendorId}/category`, {
      params,
      cancelToken: cancelTokenHandlerObject[this.all.name].handleRequestCancellation().token
    });
  },
  show: function (vendorId: number | string, id: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/vendor/${vendorId}/category/${id}`, {
      params,
      cancelToken: cancelTokenHandlerObject[this.show.name].handleRequestCancellation().token
    });
  },
};

export default Repository;

const cancelTokenHandlerObject = createCancelTokenHandler(Repository);
